// extracted by mini-css-extract-plugin
export var label = "tags-module--label--0ce50";
export var listTags = "tags-module--listTags--a8fc6";
export var tags = "tags-module--tags--c7ddd";